const RESERVATION_URL = 'https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb';

export default function MobileBottomNav() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-100"
      style={{
        boxShadow: '0 -4px 20px rgba(0,0,0,0.10)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div className="flex items-stretch h-16">
        {/* 電話ボタン */}
        <a
          href="tel:05018094594"
          className="flex flex-col items-center justify-center gap-1 px-5 min-w-[76px] text-gray-500 active:bg-gray-50 transition-colors"
          aria-label="電話で相談する"
        >
          <i className="fa-solid fa-phone text-base" style={{ color: '#3E5F8F' }} />
          <span className="text-[10px] font-medium leading-none whitespace-nowrap">電話で相談</span>
        </a>

        <div className="w-px bg-gray-100 my-3 flex-shrink-0" />

        {/* WEB予約ボタン（Primary） */}
        <a
          href={RESERVATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 mx-3 my-2.5 rounded-full text-white font-bold text-sm active:opacity-90 transition-opacity select-none"
          style={{ backgroundColor: '#3E5F8F' }}
          aria-label="WEB予約（無料）"
        >
          <i className="ri-calendar-check-line text-base flex-shrink-0" />
          <span className="whitespace-nowrap">空き確認・WEB予約（無料）</span>
        </a>
      </div>
    </div>
  );
}
